var render = function render(_c,_vm){return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_c('span',[_vm._v("COPYRIGHT © "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"https://www.sbt.com.br","target":"_blank","rel":"nofollow"}},[_vm._v("SBT.com.br")]),_vm._v(", Todos os direitos reservados")])])
}
var staticRenderFns = []

export { render, staticRenderFns }